import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom';
import { connect, useSelector, shallowEqual, useDispatch } from 'react-redux';
import Badge from '../../atoms/badge/badge';
import Label from '../../atoms/label/label';
import swal from 'sweetalert';
import { IconType } from '../../atoms/icon/icon';
import Button, { ButtonTheme } from '../../atoms/button/button';
import Modal, { ModalSize } from '../../molecules/modal/modal';
import { getItems, createItem, removeItem, tableEdited, updateItems } from '../../../store/externalCalls/api/secondaryListTableApi';
import TableSection from '../tableSection/tableSectionv2';
import { storeStructure } from '../../../store/reducers';
import { getCatalog } from '../../../store/externalCalls/api/listTableApi';
import { composeURL, appendParamsToURL } from '../../../utils/urlTools';
import { Accordion, Card } from 'react-bootstrap';
import UploadDragAndDrop from '../../molecules/uploadDragAndDrop/uploadDragAndDrop';
import FormInputText from '../../molecules/formInputText/formInputText';

const FormRelationship = (props) => {
  const {
    value, helpText, label, isForm, configFile, onChange, onCreate, onDelete, onSave, buttonColor, type, itemId, newAlways,onClose
  } = props;

  const params = useParams();
  const dispatch = useDispatch();
  const [openModal, setOpenModal] = useState(false);
  const [paginateValues, setPaginatedValues] = useState({});
  const [updatedValues, setUpdateValues] = useState();
  const [errors, setErrors] = useState({});
  const session = useSelector((state) => state[storeStructure.Session], shallowEqual);
  const [itemsSelected, setItemsSelected] = useState(Object.keys(value).length > 0 ? [value] : []);
  const id = configFile.idAttribute !== undefined
    ? params[configFile.idAttribute] : undefined;
  const handlerClickRow = (newItemSelected, item) => {
    newItemSelected["type"] = item.attributeName;
    if(item.tableConfig.isMultiSelectable==false){
      setItemsSelected([newItemSelected]);
    }else
      setItemsSelected(newItemSelected);
  };
  const handlerClickButton = (item) => {
    let newItem = {}
    newItem.type= item.attributeName;
    newItem.name = item.attributeName;
    if(item.itemType !== "videoPoster" && item.itemType !== "interactableGraphic"){
      onChange({ target: { value: newItem } });
      handlerCloseModal();
    }
  };
  const handlerChangePage = (e) => {
    getData(e);
  };
  const getData = (changePage, config) => {
      getItems(changePage || composeURL(session, config.sessionParams, config.getURL))
        .then((paginatedItems) => {
          setPaginatedValues(paginatedItems);
          (value.length > 0) ? setItemsSelected(value) : setItemsSelected(itemsSelected);
        });
  };
  const handlerOpenModal = () => {
    onCreate();
    setOpenModal(true);
  };

  const handlerCloseModal = () => {
    setOpenModal(false);
    onClose();
  };

  const handlerCreate = (item) => {
    setErrors({});
    const url = composeURL(session, configFile.sessionParams, configFile.createURL, id);
    createItem(
      url,
      item,
      dispatch,
    ).then(() => {
      // eslint-disable-next-line max-len
      getItems(composeURL(session, configFile.sessionParams, configFile.getURL)).then((paginatedItems) => {
        setPaginatedValues(paginatedItems);
        setOpenModal(true);
      });
    }, (e) => {
      handlerErrors(e);
    });
  };
  const handlerRemoveItem = (item) => {
    swal({
      title: 'Are you sure?',
      text: 'You are removing a item.',
      icon: 'warning',
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        const url = composeURL(session, configFile.sessionParams, configFile.removeURL, id);
        removeItem(url, item, dispatch).then((result) => {
          getData();
          onDelete(result);
        }, (e) => {
          handlerErrors(e);
        });
      }
    });
  };
  const handlerUpdate = (dataSet) => {
    setUpdateValues(dataSet);
    if (configFile.autoUpdate === true) {
      const url = composeURL(session, configFile.sessionParams, configFile.updateURL, id);

      updateItems(url, dataSet, dispatch)
        .then(() => {
          onSave();
        }, (e) => {
          handlerErrors(e);
        });
    } else {
      tableEdited(dispatch);
    }
  };

  const handlerSave = (item) => {
    onChange({ target: { value: itemsSelected } });
    handlerCloseModal();
  };

  const handlerErrors = (e) => {
    const messages = e.errors === undefined ? { general: 'Something was wrong' } : e.errors;

    setErrors(messages);
    setTimeout(() => {
      setErrors({});
    }, 5000);
  };

  const handlerSort = (sort, item) => {
    const { attributeName, sortDown } = sort;
    const orderList = sortDown ? 'asc' : 'desc';
    const obj = {
      sort_by: attributeName,
      order: orderList,
    };
    const url = composeURL(session, item.sessionParams, item.getURL, id);
    const searchURL = appendParamsToURL(url, obj);

    getCatalog(searchURL).then((response) => {
      setPaginatedValues(response);
    });
  };

  const handlerSearch = (filters, item) => {
    const searchURL = appendParamsToURL(composeURL(session, item.sessionParams, item.getURL, id), filters);
    getCatalog(searchURL).then((response) => {
      setPaginatedValues(response);
    });
  };

  const handlerOnClickBadge = (item) => {
    swal({
      title: 'Remove '+item.name+'?',
      text: 'You are removing a item from the postermatrix and there´s no way back from this action.',
      icon: 'warning',
      buttons: true,
      dangerMode: true,
    }).then((ok) => {
      if (ok) {
        if (Array.isArray(value)) {
          const newItems = [...value];
          newItems.splice(newItems.indexOf(item), 1);
          onChange({ target: { value: newItems } });
        } else {
          onChange({ target: { value: {} } });
        }
      }
    });
  };
  const handleUploadCompleted = (result, item) => {
    const { uploadURL } = result.successful[0].response;
    const publicFolder = uploadURL.substr(uploadURL.lastIndexOf('/'));
    const extension = result.successful[0].extension;
    const publicFileUrl = `${process.env.REACT_APP_BACKEND_URL + process.env.REACT_APP_PUBLIC_UPLOADS + publicFolder + publicFolder}.${extension}`;

    let newItem = {}
    newItem.type= item.attributeName;
    newItem.name = item.attributeName;
    newItem.url = publicFileUrl;
    setItemsSelected([]);
    onChange({ target: { value: newItem } });
    handlerCloseModal();
  };

  const handleInteractableURLChnage = (event, item) => {
    let newItem = {};
    newItem.type= item.attributeName;
    newItem.name = item.attributeName;
    newItem.url = event.target.value;
    setItemsSelected([]);
    onChange({ target: { value: newItem } });
  };

  return (
    <div className={isForm === true ? 'form-group row' : ''}>
      { label !== ''
        && (
          <Label helpText={helpText}>{label}</Label>
        )}
      <div className={isForm === true ? 'col-sm-8' : ''}>
        {Array.isArray(value) && value.map((val) => (
          <Badge
            className="mr-1"
            key={val[configFile.itemId]}
            icon={IconType.CLOSE}
            onClick={() => handlerOnClickBadge(val)}
          >
            {val[configFile.itemName]}
          </Badge>
        ))}
        {!Array.isArray(value) && value[configFile.itemId] !== undefined
          && (
            <Badge
              className="mr-1"
              key={value[configFile.itemId]}
              icon={IconType.CLOSE}
              onClick={() => handlerOnClickBadge(value)}
            >
              {value[configFile.itemName]}
            </Badge>
          )}
          {!Array.isArray(value) && value['name'] !== undefined && value[configFile.itemId] == undefined
          && (
            <Badge
              className="mr-1"
              key={value[configFile.itemId]}
              icon={IconType.CLOSE}
              onClick={() => handlerOnClickBadge(value)}
            >
              {value["name"]}
            </Badge>
          )}
        {(configFile.isMultiSelectable || value[configFile.itemId] === undefined || newAlways)
          && (
            <Button
              id={`add-item-${itemId}`}
              theme={buttonColor ? buttonColor : ButtonTheme.PRIMARY}
              icon={IconType.NEW}
              onClick={handlerOpenModal}
            />
          )}
      </div>
      { openModal === true
      && (
        <Modal
          title={configFile.label}
          onClose={handlerCloseModal}
          size={ModalSize.LARGE}
        >
         <div>
         <Accordion>
         {
              configFile.configFile.map((item, key)=>{
                return (
                  <Card key={key}>
                    <Card.Header>
                      <Accordion.Toggle as={Button} 
                        variant="link" id={`accordion-${item.attributeName}`} onClick={()=> (item.itemType && (item.itemType == "button" || item.itemType == "videoPoster" || item.itemType == "interactableGraphic")) ? handlerClickButton(item):  getData(null, item)} eventKey={""+key}>
                        {item.title}
                      </Accordion.Toggle>
                    </Card.Header>
                    {
                      (!item.itemType && item.itemType !== "button" && item.itemType !== "videoPoster" && item.itemType !== "interactableGraphic") &&
                      <Accordion.Collapse eventKey={""+key}>
                        <Card.Body>
                          {
                            Object.keys(paginateValues).length !== 0 
                              && (
                                <TableSection
                                  configFile={item.tableConfig}
                                  valuesPaginated={paginateValues}
                                  onChangePage={handlerChangePage}
                                  onClickRow={(obj)=>handlerClickRow(obj, item)}
                                  onChangeItem={handlerUpdate}
                                  onClickCreate={handlerCreate}
                                  onClickRemoveItem={handlerRemoveItem}
                                  onSearch={(obj)=>handlerSearch(obj, item)}
                                  onSort={(obj)=>handlerSort(obj, item)}
                                  initDataSelected={item.tableConfig.isMultiSelectable === true ? itemsSelected : []}
                                />
                              )
                          }
                        </Card.Body>
                    </Accordion.Collapse>
                    }
                   {
                      (item.itemType && (item.itemType == "videoPoster")) &&
                      <Accordion.Collapse eventKey={""+key}>
                        <Card.Body>
                          {
                            <div>
                              <UploadDragAndDrop onCompleted={(img)=>handleUploadCompleted(img, item)} />
                            </div>
                          }
                        </Card.Body>
                    </Accordion.Collapse>
                    }
                    {
                      (item.itemType && (item.itemType == "interactableGraphic")) &&
                      <Accordion.Collapse eventKey={""+key}>
                        <Card.Body>
                          {
                            <div>
                              <FormInputText
                                id="inputInteractableGraphic-url"
                                name={item.label}
                                label={item.label}
                                type={item.type}
                                helpText={item.helpText}
                                onChange={(event) => handleInteractableURLChnage(event, item)}
                              />
                            </div>
                          }
                        </Card.Body>
                    </Accordion.Collapse>
                    }
                  </Card>
                )})
        }
        </Accordion>
         </div>
          <div>
            {(itemsSelected && itemsSelected.length > 0)&&
              <Button
                id='button-accept'
                theme={ButtonTheme.PRIMARY}
                onClick={handlerSave}
                disabled={itemsSelected === undefined}
              >
              Ok
            </Button>
            }
            
            {(itemsSelected == undefined || itemsSelected.length == 0) &&
              <Button
                id='button-accept'
                theme={ButtonTheme.PRIMARY}
                onClick={handlerCloseModal}
                disabled={itemsSelected === undefined}
              >
              Ok
            </Button>
            }
          </div>
        </Modal>
      )}
    </div>
  );
};

FormRelationship.propTypes = {
  /**
   * Object or array with the info of the selected items
   */
  value: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.shape({})),
    PropTypes.shape({}),
  ]),
  /**
   * Config file with the attributes to init the component
   */
  configFile: PropTypes.shape({
    itemId: PropTypes.string,
    getURL: PropTypes.string,
    itemName: PropTypes.string,
    createURL: PropTypes.string,
    removeURL: PropTypes.string,
    autoUpdate: PropTypes.bool,
    updateURL: PropTypes.string,
    idAttribute: PropTypes.string,
    title: PropTypes.string,
    sessionParams: PropTypes.arrayOf(PropTypes.string),
    tableConfig: PropTypes.shape({
      isMultiSelectable: PropTypes.bool,
    }),
  }).isRequired,
  /**
   * On change event
   */
  onChange: PropTypes.func,
  /**
   * On create event
   */
  onCreate: PropTypes.func,
  /**
   * On delete event
   */
  onDelete: PropTypes.func,
  /**
   * On save event
   */
  onSave: PropTypes.func,
  /**
   * If this componen is draw in a form
   */
  isForm: PropTypes.bool,
  /**
   * Description label of the component
   */
  label: PropTypes.string,
  /**
   * User help text for the form
   */
  helpText: PropTypes.string,
  /**
   * The component shows the new button always
   */
  newAlways: PropTypes.bool,
};

FormRelationship.defaultProps = {
  label: '',
  helpText: '',
  value: [],
  onChange: () => {},
  onCreate: () => {},
  onDelete: () => {},
  onSave: () => {},
  isForm: false,
  newAlways: false,
};

export default connect()(FormRelationship);
